import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import WhatIsSection from './components/WhatIsSection';
import FeaturesSection from './components/FeaturesSection';
import CategoriesSection from './components/CategoriesSection';
import SellerComparisonSection from './components/SellerComparisonSection';
import SafetySection from './components/SafetySection';
import GuidesSection from './components/GuidesSection';
import TestimonialsSection from './components/TestimonialsSection';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';

const siteUrl = 'https://allchinabuyspreadsheet.bar';
const logoUrl = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/14bc629c50c04cb08f38590896596985.jpeg';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <article>
          <HeroSection />
          <WhatIsSection />
          <FeaturesSection />
          <CategoriesSection />
          <SellerComparisonSection />
          <SafetySection />
          <GuidesSection />
          <TestimonialsSection />
          <FaqSection />
          <CtaSection />
        </article>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@graph': [
              {
                '@type': 'WebSite',
                '@id': `${siteUrl}/#website`,
                url: siteUrl,
                name: 'AllChinaBuySpreadsheet',
                description: 'Discover the best AllChinaBuy Spreadsheet for 2026. Compare trusted sellers, product quality, prices, and safe shopping guides.',
                inLanguage: 'en',
                potentialAction: {
                  '@type': 'SearchAction',
                  target: {
                    '@type': 'EntryPoint',
                    urlTemplate: `${siteUrl}/?q={search_term_string}`,
                  },
                  'query-input': 'required name=search_term_string',
                },
              },
              {
                '@type': 'Organization',
                '@id': `${siteUrl}/#organization`,
                url: siteUrl,
                name: 'AllChinaBuySpreadsheet',
                description: 'Your trusted resource for curated AllChinaBuy spreadsheets with verified sellers, product quality comparisons, and safe buying guides.',
                logo: {
                  '@type': 'ImageObject',
                  url: logoUrl,
                  width: '512',
                  height: '512',
                },
                sameAs: [
                  'https://kaspreadsheet.com',
                ],
              },
              {
                '@type': 'WebPage',
                '@id': `${siteUrl}/#webpage`,
                url: siteUrl,
                name: 'Best AllChinaBuy Spreadsheet 2026 — Trusted Sellers, Verified Links & Buying Guides',
                description: 'Discover the best AllChinaBuy Spreadsheet for 2026. Compare trusted sellers, product quality, prices, and safe shopping guides. Updated spreadsheet links for shoes, hoodies, clothing, accessories and more.',
                inLanguage: 'en',
                isPartOf: {
                  '@id': `${siteUrl}/#website`,
                },
                about: {
                  '@id': `${siteUrl}/#organization`,
                },
                datePublished: '2026-06-25',
                dateModified: '2026-06-25',
              },
            ],
          }),
        }}
      />
    </>
  );
}